// Types sourced from the generated OpenAPI schema (../api.gen.d.ts).
// Regenerate with scripts/generate-www-api-types.sh after backend changes.
import type { components } from '../api.gen';
import type { JobStatus } from './monitoring';

export type JobListItem = components['schemas']['_JobInfo'];

// The backend restricts status_counts keys to JobStatus via `propertyNames`,
// which openapi-typescript cannot express (it generates a plain string index
// signature) — so narrow the record here, keyed by the derived JobStatus.
export type JobStatusCounts = Partial<Record<JobStatus, number>>;

export type JobsResponse = Omit<
  components['schemas']['JobsResponse'],
  'status_counts'
> & { status_counts: JobStatusCounts };

// Client-only types below: UI state, not part of the API contract.

export type JobsScope = 'mine' | 'all';

// `unknown` is local-only: the server only ever returns a value from JobStatus,
// but the badge needs a representation for "not loaded / failed to load".
export type JobBadgeStatus = JobStatus | 'unknown';

export const BADGE_STATUSES: ReadonlySet<JobBadgeStatus> =
  new Set<JobBadgeStatus>([
    'pending',
    'running',
    'waiting_for_capacity',
    'importing',
    'stuck',
    'complete',
    'failed',
    'deleted',
    'unknown',
  ]);

export interface JobsFilterState {
  scope: JobsScope;
  search: string;
  status: JobStatus | null;
  // Server-side filter (forwarded to /meta/jobs as `waiting=1`): show only runs
  // parked on a human approval (pending_interactions > 0).
  waiting: boolean;
  page: number;
}
